import React from "react";
import { CygnusTooltip } from "reusable-components/CygnusTooltip/CygnusTooltip";
import styles from "./GridCellTooltip.module.css";
import type { GridCellTooltipProps } from "./GridCellTooltip.types";

export const GridCellTooltip: React.FC<GridCellTooltipProps> = ({
  text,
  children,
  placement = "top-start",
}) => {
  const tooltipText = text == null ? "" : String(text);

  if (children) {
    return (
      <CygnusTooltip text={tooltipText} placement={placement}>
        <span className={styles.tooltipTarget}>{children}</span>
      </CygnusTooltip>
    );
  }

  return (
    <CygnusTooltip text={tooltipText} placement={placement}>
      <span className={styles.tooltipText}>{tooltipText}</span>
    </CygnusTooltip>
  );
};
